/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/user_profiles-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/user_profiles-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/user_profiles-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-user_profiles-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/user_profiles.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-10-03T04:55:47.871Z
 * Source config: config/entities/user_profiles-entity-config.ts
 * Public fields: 16/16 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const UserProfilesSchema = Type.Object({
  id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // id field - primary key
  email: Type.Union([Type.String({ format: "email" }), Type.Null()]), // email field
  full_name: Type.String(), // full_name field
  avatar_url: Type.Union([Type.String(), Type.Null()]), // avatar_url field
  phone_number: Type.Union([Type.String(), Type.Null()]), // phone_number field
  settings: Type.Union([Type.String(), Type.Null()]), // settings field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field - auto-managed timestamp
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field - auto-managed timestamp
  organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // organization_id field
  auth_user_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // auth_user_id field
  builder_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // builder_id field
  trig_role_name: Type.Union([Type.String(), Type.Null()]), // trig_role_name field - trigger-populated denormalized field
  session_valid_after: Type.Union([Type.String(), Type.Null()]), // session_valid_after field
  is_active: Type.Union([Type.Boolean(), Type.Null()]), // is_active field - soft-delete flag (false = account deactivated)
  deactivated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // deactivated_at field - timestamp the account was deactivated
  deactivated_by: Type.Union([Type.String(), Type.Null()]), // deactivated_by field - user_profiles.id of the admin who deactivated the account
});

export const CreateUserProfilesSchema = Type.Object({
  email: Type.Union([Type.String({ format: "email" }), Type.Null()]), // email field
  full_name: Type.String(), // full_name field
  avatar_url: Type.Union([Type.String(), Type.Null()]), // avatar_url field
  phone_number: Type.Union([Type.String(), Type.Null()]), // phone_number field
  settings: Type.Union([Type.String(), Type.Null()]), // settings field
  organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // organization_id field
  auth_user_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // auth_user_id field
  builder_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // builder_id field
  session_valid_after: Type.Union([Type.String(), Type.Null()]), // session_valid_after field
});

export const UpdateUserProfilesSchema = Type.Object({
  email: Type.Union([Type.String({ format: "email" }), Type.Null()]), // email field
  full_name: Type.String(), // full_name field
  avatar_url: Type.Union([Type.String(), Type.Null()]), // avatar_url field
  phone_number: Type.Union([Type.String(), Type.Null()]), // phone_number field
  settings: Type.Union([Type.String(), Type.Null()]), // settings field
  organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // organization_id field
  auth_user_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // auth_user_id field
  builder_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // builder_id field
  session_valid_after: Type.Union([Type.String(), Type.Null()]), // session_valid_after field
  is_active: Type.Union([Type.Boolean(), Type.Null()]), // is_active field - soft-delete flag (false = account deactivated)
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type UserProfilesRow = Static<typeof UserProfilesSchema>;
export type UserProfilesInsert = Static<typeof CreateUserProfilesSchema>;
export type UserProfilesUpdate = Static<typeof UpdateUserProfilesSchema>;

// Legacy type aliases for backward compatibility
export type UserProfiles = UserProfilesRow;
export type CreateUserProfiles = UserProfilesInsert;
export type UpdateUserProfiles = Static<typeof UpdateUserProfilesSchema>;

// Field configuration metadata
export const UserProfilesFieldConfig = {
  filterable: ['id', 'organization_id', 'auth_user_id', 'builder_id', 'is_active'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['full_name'] as const,
  readonly: ['id', 'created_at', 'updated_at', 'trig_role_name', 'deactivated_at', 'deactivated_by'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../../config/search/global-search-config.js';

export interface UserProfilesQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface UserProfilesResponse {
  data: UserProfiles[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleUserProfilesResponse {
  data: UserProfiles | null;
  error: Error | null;
}
